<ng-container *ngIf="showLoadingOverlay" [ngTemplateOutlet]="loadingTemplate"></ng-container>

<!-- Loading template to overlay the entire page -->
 <ng-template #loadingTemplate>
  <div class="neptune-modal-cover">
        <loader [size]="'medium'"></loader>
  </div>
</ng-template>

<div class="refreshed-tvd-drillin flex flex-col flex-grow px-8 py-6 gap-6 justify-between h-auto ml-20 bg-light-blue">
    <!-- TVD Metric tile section -->
    <div class=" tvd-metric-tile-section flex justify-between items-center pb-4 border-0 border-b-2 border-solid neptune-subtle">
        <div class="tvd-metric-tile-header flex items-center gap-2">
            <div (click)="goBackToMainTvdPage()" id="tvd-details-breadcrumb" class="flex items-center cursor-pointer">
                <img src="assets/shared-icons/neptune-icon-blue-left-chevron.svg" alt="Back to TVD Main Page" class="w-5 h-5" />
            </div>
            <span class="text-3xl font-normal text-gray-800">{{ (showInEnterpriseTerms ? enterpriseTermDisplayName :
                metricDisplayName) | capitalize }}</span>
        </div>
        <div *ngIf="costAssumptionsVisible" class="adjust-cost-assumption px-4 py-2 bg-gray-100 flex items-center gap-2">
            <button class="border border-blue-600 text-blue-600 neptune-button-white" (click)="openSideDrawer()">
                <img src="assets/shared-icons/neptune-currency-refresh-icon.svg" alt="Adjust Cost Assumption" class="w-4 h-4" />
                Adjust Cost Assumption
            </button>
        </div>
    </div>

    <!-- Tabs -->
    <div class="tvd-drill-down-tabs bg-white flex">
        <button id="tvd-location-drill-down-tab" class="flex-1 py-3 text-sm font-medium appearance-none focus:ring-0 bg-transparent border-0 border-b-2 rounded-none cursor-pointer text-neptune-neutral"
            [ngClass]="{'border-solid  border-blue': tabSelected == TvdDrillDownGrouping.Location,'border-transparent': tabSelected !== TvdDrillDownGrouping.Location}" (click)="changeTab(TvdDrillDownGrouping.Location)">
            By Location
        </button>

        <button *ngIf="!isPestView()" id="tvd-product-drill-down-tab" class="flex-1 py-3 text-sm font-medium appearance-none focus:ring-0 bg-transparent border-0 border-b-2 rounded-none cursor-pointer text-neptune-neutral"
            [ngClass]="{'border-solid border-blue': tabSelected == TvdDrillDownGrouping.Product,'border-transparent': tabSelected !== TvdDrillDownGrouping.Product}" (click)="changeTab(TvdDrillDownGrouping.Product)">
            By Product
        </button>
    </div>



    <!-- KPIS -->
    <section>
        <ng-container *ngIf="kpiCardsLoaded; else kpiLoader">
            <app-tvd-kpi-grid [currencySymbol]="currencySymbol" [metrics]="tvdDrillInMetricTiles"></app-tvd-kpi-grid>
        </ng-container>
        <ng-template #kpiLoader>
            <div class="neptune-modal-cover">
                <loader [size]="'medium'"></loader>
            </div>
        </ng-template>
    </section>

    <!-- Export Button -->
    <div id="refresh-export" class="flex justify-end gap-2" (click)="onExportBtnClick()">
        <div class="tvd-export-btn py-2 bg-gray-100 flex items-center gap-2">
            <button class="border border-blue-600 text-blue-600 neptune-button-blue">
                <img src="assets/shared-icons/neptune-download-icon.svg" alt="Export" class="w-4 h-4" />
                Export Table
            </button>
        </div>
    </div>

    <div class="tvd-export-modal-close fixed inset-0 w-full h-full bg-black bg-opacity-80 z-[999]" *ngIf="isExportModalOpen"
        (click)="closeExportModal()"></div>
    <app-export-dialog *ngIf="isExportModalOpen" [isDownloading]="isExportDownloading" [title]="exportModalTitle"
        [additionalMixpanelProperties]="additionalExportProperties" [mixpanelEventName]="exportMixpanelEventName"
        [fileName]="exportFileName" [showSelectFileType]="false" (export)="handleExport($event)"
        (cancel)="closeExportModal()">
    </app-export-dialog>

    <!-- Advanced Filters Section -->
    <loader [size]="'small'" *ngIf="displayLoaderForFilterData"></loader>
    <div id="tvd-advanced-filters" class="tvd-drillin-advancefilters neptune-advanced-filters"
        *ngIf="shouldShowAdvancedFilters() && !displayLoaderForFilterData && advancedFilterData.length > 0">
        <advanced-filters [advancedFilterData]="advancedFilterData" [pageScope]="'TVD ' + tabSelected + ' view'"
            [excludeKeys]="excludeKeys" [selectedAdvancedFilters]="currentSelectedFilters"
            (selectedFilters)="onSelectedFiltersChange($event)" [useRefreshedUi]="true"
            [(toggleBody)]="toggleAdvancedFilterSelection">
        </advanced-filters>
        <advanced-filters-selection
            [advancedFilterData]="advancedFilterData"
            [excludeKeys]="excludeKeys"
            [pageScope]="'TVD ' + tabSelected + ' view'"
            [selectedAdvancedFilters]="currentSelectedFilters"
            (selectedFilters)="onSelectedFiltersChange($event)"
            [(toggleBody)]="toggleAdvancedFilterSelection"
        >
        </advanced-filters-selection>
    </div>

    <!-- Paginator section -->
    <div class="tvd-drillin-paginator mt-2.5 bg-light-blue">
        <!-- Paginator for 'product' -->
        <mat-paginator *ngIf="tabSelected === TvdDrillDownGrouping.Product && !isPestView()" #productPaginator
            class="tvd-drillin-paginator-product"
            (page)="onPageChange($event)"
            [length]="tvdProductsRowData?.length"
            [pageSize]="100"
            [showFirstLastButtons]="true"
            [pageSizeOptions]="[25, 50, 75, 100]"
            aria-label="Select page">
        </mat-paginator>

        <!-- Paginator for 'location' -->
        <mat-paginator *ngIf="tabSelected === TvdDrillDownGrouping.Location && !isPestView()" #locationPaginator
        class="tvd-drillin-paginator-location" [pageSize]="100"
            [pageSizeOptions]="[25, 50, 75, 100]"
            [length]="tvdLocationRowData?.length"
            (page)="onPageChange($event)"
            [showFirstLastButtons]="true"
            aria-label="Select page">
        </mat-paginator>

        <!-- Paginator for Pest Services by location -->
        <mat-paginator *ngIf="tabSelected === TvdDrillDownGrouping.Location && isPestView()" #locationPaginator
            class="tvd-drillin-paginator-pest-location" [pageSize]="100"
            [pageSizeOptions]="[25, 50, 75, 100]"
            [length]="tvdLocationServicesRowData?.length"
            (page)="onPageChange($event)"
            [showFirstLastButtons]="true"
            aria-label="Select page">
        </mat-paginator>
    </div>

     <!-- By Location table section -->
    <section id="tvd-location-details-table" class="tvd-location-details-table w-full pb-8 bg-neptune-muted"
        *ngIf="tabSelected === TvdDrillDownGrouping.Location && !displayLoader && !isPestView()">
        <!-- Location table header block -->
        <div class="tvd-location-header flex justify-start items-center text-sm leading-5 font-medium self-stretch rounded-tl-[8px]">
            <ng-container *ngFor="let column of tableLocationHeaderColumns">
                <div class="{{column.neptuneCssClass}} neptune-default py-2.5 px-4 gap-1
                                        tvd-location-header-{{column.sortBy}} flex items-center group" id="tvd-location-header-{{column.sortBy}}">

                    <div class="flex items-center justify-between w-full">
                        <span>{{column.title}}</span>

                        <img alt="sort-arrow"
                            class="sort-arrow-img ml-2 transition-opacity opacity-0 group-hover:opacity-100 cursor-pointer"
                            [ngClass]="{
                                    'opacity-100': locationSortBy === column.sortBy,
                                    'rotate-0': locationSortBy === column.sortBy && column.sortDirection === 'asc',
                                    'rotate-180': locationSortBy === column.sortBy && column.sortDirection === 'desc'
                                }" src="assets/shared-icons/neptune-icon-arrow-up.svg"
                            (click)="toggleSortDirectionData(column)" [attr.data-id]="'sort-arrow-' + column.sortBy"
                            attr.aria-label="Sort {{column.title}}" />
                    </div>

                </div>
            </ng-container>
        </div>

        <!-- Location table rows -->
        <ng-container *ngIf="tvdLocationRowData?.length; else noData">
            <ng-container *ngFor="let location of tvdLocationRowDataPaginated; let i = index;">
                <div class="location-row flex items-center text-sm neptune-default leading-5 font-normal justify-unset odd:bg-neptune-muted even:bg-white" id="tvd-locations-row">
                    <div class="w-[30%] py-2 px-4 gap-2 location-siteinfo" id="location-siteinfo">
                        <div class="w-[90%]" id="site-name">{{location.siteName | capitalize}}</div>
                        <div class="w-[90%]">{{getLocationSiteInfo(location)}}</div>
                    </div>
                    <div class="w-[15%] py-2 px-4 location-contributing-products" id="location-contributing-products">
                        {{getFormattedDisplayNumber(location.contributingProducts)}}
                    </div>
                    <div class="w-[15%] py-2 px-4 location-percent-total" id="location-percent-total">
                        {{getFormattedDisplayNumber(location.percentOfTotal)}}%
                    </div>
                    <div class="w-[15%] py-2 px-4 location-estimated-metric-dollars" id="location-estimated-metric-dollars">
                        <span *ngIf="!isNoDollarValueMetric()">{{getFormattedDisplayNumber(getRowEstimatedMetricDollars(location),
                            true)}}</span>
                        <span *ngIf="isNoDollarValueMetric()">N/A</span>
                    </div>
                    <div class="w-[25%] py-2 px-4 location-estimated-metric-quantity" id="location-estimated-metric-quantity">
                        <span>{{getFormattedDisplayNumber(location.estimatedMetricQuantity)}}
                            {{tvdLocationDetailsData?.metricUnit}}</span>
                    </div>
                </div>
            </ng-container>
        </ng-container>
    </section>

        <!-- By Product table section -->
    <section id="tvd-product-details-table" class="tvd-product-table w-full pb-8 bg-neptune-muted border-b border-neptune-border-subtle" *ngIf="tabSelected === TvdDrillDownGrouping.Product && !displayLoader && !isPestView()">
        <!-- Products table header block -->
        <div class="tvd-drillin-product-header flex justify-start items-center text-sm leading-5 font-medium self-stretch rounded-tl-[8px]">
            <ng-container *ngFor="let column of tableProductHeaderColumns">
                <div class="{{column.neptuneCssClass}} neptune-default py-2.5 px-4 gap-1 tvd-product-header-{{column.sortBy}} flex items-center group"
                id="tvd-product-header-{{column.sortBy}}">

                    <!-- Flex row: title + icon -->
                    <div class="flex items-center justify-between w-full">
                        <span>{{column.title}}</span>

                        <img alt="sort-arrow"
                            class="sort-arrow-img ml-2 transition-opacity opacity-0 group-hover:opacity-100 cursor-pointer"
                            [ngClass]="{
                                    'opacity-100': productSortBy === column.sortBy,
                                    'rotate-0': productSortBy === column.sortBy && column.sortDirection === 'asc',
                                    'rotate-180': productSortBy === column.sortBy && column.sortDirection === 'desc'
                                }" src="assets/shared-icons/neptune-icon-arrow-up.svg"
                            (click)="toggleSortDirectionData(column)" [attr.data-id]="'sort-arrow-' + column.sortBy"
                            attr.aria-label="Sort {{column.title}}" />
                    </div>

                </div>
            </ng-container>
        </div>


        <!-- Products table rows -->
        <ng-container *ngIf="tvdProductsRowData?.length; else noData">
            <ng-container *ngFor="let product of tvdProductsRowDataPaginated; let i = index;">
                <div class="tvd-drillin-product-row flex items-center text-sm tvd-default leading-5 font-normal justify-unset odd:bg-neptune-muted even:bg-white">
                    <div class="w-[15%] px-4 py-2 gap-2 tvd-product-productinfo">
                        <div class="productDesc">{{product.productDesc | capitalize}}</div>
                        <div class="productCode">{{product.productCode}}</div>
                    </div>
                    <div class="w-[15%] px-4 py-2 tvd-product-solution">
                        {{product.solution | capitalize}}
                    </div>
                    <div class="w-[10%] px-4 py-2 product-percent-total">
                        {{getFormattedDisplayNumber(product.percentOfTotal)}}%
                    </div>
                    <div class="w-[10%] px-4 py-2 product-number-of-locations">
                        {{getFormattedDisplayNumber(product.numberOfLocations)}}
                    </div>
                    <div class="w-[10%] px-4 py-2 product-quantity-purchased">
                        {{getFormattedDisplayNumber(product.quantityPurchased)}} {{ getMeasurementUnit(product) }}
                    </div>
                    <div class="w-[15%] px-4 py-2 product-estimated-metric-dollars">
                        <span *ngIf="!isNoDollarValueMetric()">{{getFormattedDisplayNumber(getRowEstimatedMetricDollars(product), true)}}</span>
                        <span *ngIf="isNoDollarValueMetric()">N/A</span>
                    </div>
                    <div class="w-[20%] px-4 py-2 product-estimated-metric-quantity">
                        <span *ngIf="metricName !== 'Cost Avoidance'">{{getFormattedDisplayNumber(product.estimatedMetricQuantity)}} {{tvdProductDetailsData?.metricUnit}}</span>
                        <span *ngIf="metricName === 'Cost Avoidance'">N/A</span>
                    </div>
                </div>
            </ng-container>
        </ng-container>
    </section>

    <!-- Pest By Location table section -->
    <section id="tvd-pest-location-details-table" class="w-full pb-8 bg-neptune-muted border-b border-neptune-border-subtle" *ngIf="tabSelected === 'location' && !displayLoader && isPestView()">
        <!-- Location table header block -->
        <div class="flex justify-start items-center gap-1 text-sm leading-5 font-medium self-stretch rounded-tl-[8px]">

            <ng-container *ngFor="let column of tableLocationServicesHeaderColumns">
                <div class="{{column.neptuneCssClass}} neptune-default py-2.5 px-4 gap-1 neptune-location-header-{{column.sortBy}} flex items-center group"
                id="neptune-location-header-{{column.sortBy}}">

                    <!-- Flex row: title + icon -->
                    <div class="flex items-center justify-between w-full">
                        <span>{{column.title}}</span>

                        <img alt="sort-arrow"
                            class="sort-arrow-img ml-2 transition-opacity opacity-0 group-hover:opacity-100 cursor-pointer"
                            [ngClass]="{
                                            'opacity-100': locationServicesSortBy === column.sortBy,
                                            'rotate-0': locationServicesSortBy === column.sortBy && column.sortDirection === 'asc',
                                            'rotate-180': locationServicesSortBy === column.sortBy && column.sortDirection === 'desc'
                                        }" src="assets/shared-icons/neptune-icon-arrow-up.svg"
                            (click)="toggleSortDirectionData(column)" [attr.data-id]="'sort-arrow-' + column.sortBy"
                            attr.aria-label="Sort {{column.title}}" />
                    </div>

                </div>
            </ng-container>
        </div>

        <!-- Pest By Location table rows -->
        <ng-container *ngIf="tvdLocationServicesRowData?.length; else noData">
            <ng-container *ngFor="let location of tvdLocationServicesRowDataPaginated; let i = index;">
                <div class="flex items-center text-sm neptune-default leading-5 font-normal justify-unset odd:bg-neptune-muted even:bg-white" id="tvd-locations-row">
                    <div class="px-4 py-2 gap-2 pest-location-siteinfo" [ngClass]="hasTwoMetrics ? 'w-[25%]' : 'w-[30%]'" id="location-siteinfo">
                        <div class="w-[90%] pest-tvd-detail-name" id="site-name">{{location.serviceAccountName | capitalize}}</div>
                        <div class="w-[90%] pest-tvd-service-account-id">{{location.serviceAccountId}}</div>
                        <div>{{getLocationSiteInfo(location)}}</div>
                    </div>
                    <div class="pest-tvd-table-row-percenttotal px-4 py-2" [ngClass]="hasTwoMetrics ? 'w-[15%]' : 'w-[20%]'" id="location-percent-total">
                        {{getFormattedDisplayNumber(location.percentOfTotal)}}%
                    </div>
                    <div class="pest-tvd-table-row-estimated-metric-dollars px-4 py-2" [ngClass]="hasTwoMetrics ? 'w-[20%]' : 'w-[25%]'" id="location-estimated-metric-dollars">
                        <span *ngIf="!isNoDollarValueMetric()">{{getFormattedDisplayNumber(location.estimatedMetricDollars, true)}}</span>
                        <span *ngIf="isNoDollarValueMetric()">N/A</span>
                    </div>
                    <div class="pest-tvd-table-row-estimated-metric-quantity px-4 py-2" [ngClass]="hasTwoMetrics ? 'w-[20%]' : 'w-[25%]'" id="location-estimated-metric-quantity">
                      <span>
                        {{getFormattedDisplayNumber(
                          metricName === ROOMS_NIGHTS_SAVED && costAssumptionValue2 > 0
                            ? location.estimatedMetricQuantity * costAssumptionValue2
                            : location.estimatedMetricQuantity
                        )}}
                      </span>
                    </div>
                    <div *ngIf="metricName === NO_CHARGE_ADDITIONAL_SERVICES"
                        class="pest-tvd-table-row-secondary-estimated-metric-quantity px-4 py-2 w-[20%]"
                        id="location-secondary-estimated-metric-quantity"
                    >
                        <span>{{getFormattedDisplayNumber(location?.estimatedSecondaryMetricQuantity)}}</span>
                    </div>
                    <div *ngIf="metricName === SETUP_SERVICES"
                        class="pest-tvd-table-row-secondary-estimated-metric-quantity px-4 py-2 w-[20%]"
                        id="location-secondary-estimated-metric-quantity"
                    >
                        <span>{{getFormattedDisplayNumber(location?.estimatedSecondaryMetricQuantity, true)}}</span>
                    </div>
                </div>
            </ng-container>
        </ng-container>
    </section>

        <!-- Display 'No Data' when there are no data on load -->
    <ng-template #noData>
        <div class="flex justify-center items-center p-[30px] bg-white rounded-[3px] shadow-[0px_3px_10px_0px_rgba(106,106,106,0.15)]">
            No Data
        </div>
    </ng-template>

    <ng-container *ngIf="isDrawerOpen">
        <app-tvd-sidenavbar
          [isOpen]="isDrawerOpen"
          [drilldownComponentTitle]="formattedMetricName"
          (closeSideDrawer)="closeSideDrawer()"
          (onSave)="onCostAssumptionsSaved()"
          [isInDrillDown]=true>
        </app-tvd-sidenavbar>
    </ng-container>

</div>
